import { render, staticRenderFns } from "./ImportShowPage.vue?vue&type=template&id=5e160490&scoped=true&"
import script from "./ImportShowPage.vue?vue&type=script&lang=js&"
export * from "./ImportShowPage.vue?vue&type=script&lang=js&"
import style0 from "./ImportShowPage.vue?vue&type=style&index=0&id=5e160490&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e160490",
  null
  
)

export default component.exports